// app/acquisto/acquisti.js

(function () {
    'use strict';
    var controllerId = 'acquisto';
    angular.module('app').controller(controllerId, ['common', 'bootstrap.dialog', '$rootScope', '$routeParams', '$filter', '$uibModal', 'datacontext', 'sectionMenu', acquisto]);

    function acquisto(common, bDialog, $rootScope, $routeParams, $filter, $uibModal, datacontext, sectionMenu) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.title = 'Acquisti';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        //Gestione sola lettura
        vm.readOnly = !$rootScope.isAuthorized('SUPER'); //&& !$rootScope.isAuthorized('GESTORE');
        vm.super = $rootScope.isAuthorized('SUPER');
        //vm.gestDid = $rootScope.isAuthorized('GESTORE');

        vm.objName = "acquisto"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.addDisabled = !vm.super; //&& !vm.gestDid;
        vm.importDisabled = true;

        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['Titolo', 'Data Scadenza'];
        vm.list.ordine = common.setOrdine(vm.list.ordine);
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            cerca();
        };

              
        //Filtro
        vm.filter = {};
        vm.filter.testo = '';        
        vm.fTesto;

                        
        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;

        vm.get = getRecord;
        
       
        //datapicker
        vm.open = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened1 = false;
            vm.opened2 = false;
            vm.opened3 = false;
            if (iOpened == 1)
                vm.opened1 = true;
            else if (iOpened == 2)
                vm.opened2 = true;
            else if (iOpened == 3)
                vm.opened3 = true;
        };

        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [];
            common.activateController(promises, controllerId)
                    .then(function () {
                        if ($routeParams.acquistoId != null) {
                            setView('detail');
                            getRecord($routeParams.acquistoId, 0);
                        }
                    });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.testo = vm.fTesto == null ? '' : vm.fTesto;
            vm.filter.anno = vm.fAnno == null ? -1 : vm.fAnno;
            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.acquisto_countByFilter(vm.filter.testo).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.acquisto_getAllByFilter(vm.pageSize, vm.page, vm.filter.testo, vm.ordine).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    data.forEach(function (item) {
                        vm.records.push(item);
                    });
                }
                vm.loading = false;
            });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {            

            return datacontext.acquisto_get(id).then(function (data) {
                vm.index = index;
                vm.record = data;               

                setView('detail');
            });
        }
                
    }
})();
